export default __webpack_public_path__ + "static/media/Mahindra-Finance-logo-Vector.d2d14bee.png";